import Vue from "vue";
import VueRouter from "vue-router";
import NotLoggedIn from "../views/NotLoggedIn.vue";
import LoggedIn from "../views/LoggedIn.vue";
import OAuthSimplyhealth from "../pages/oauth/simplyhealth/Authenticate";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import PrivacyPolicyVpc from "../pages/PrivacyPolicyVpc";
import TCs from "../pages/TCs";
import TermsAndConditionsVpc from "../pages/TermsAndConditionsVpc";
import StripeMobileRedirect from "@/pages/StripeMobileRedirect.vue";
import AccessPage from "@/pages/oauth/simplyhealth/AccessPage.vue";
import NotFound from "../pages/NotFound.vue";
import SpectrumFAQs from "../pages/SpectrumFAQs.vue";
import CancellationPolicy from "../pages/CancellationPolicy.vue";
import { handleHandover } from "@/utils/HandoverHandler";
import store from "../store";


Vue.use(VueRouter);

// const isConnectedMentalHealth = false;
// function getHomePageComponent() {
//   return isConnectedMentalHealth ? LoggedIn : LoggedIn;
// }
// const beforeEnterHandler = function (to, from, next) {
//
//   next();
// }
const routes = [
  {
    path: "/login",
    name: "NotLoggedIn",
    component: NotLoggedIn,
  },
  {
    path: "/oauth/simplyhealth/authenticate",
    name: "OAuthSimplyhealth",
    component: OAuthSimplyhealth
  },
  {
    path: "/access",
    name: "AccessPage",
    component: AccessPage,
    props: route => ({ token: route.query.token }),
  },
  {
    path: "/",
    name: "myHealth",
    component: LoggedIn,
  },
  {
    path: "/session-booking",
    name: "dmhStart",
    component: LoggedIn,
  },
  {
    path: "/transaction-success",
    name: "paymentConfirmation",
    component: LoggedIn,
  },
  {
    path: "/transaction-cancelled",
    name: "dmhTransactionCancelled",
    component: LoggedIn,
  },
  {
    path: '/my-health-area/:areaId',
    name: 'myHealthArea',
    component: LoggedIn,
    props: true,
  },
  {
    path: '/my-health-handover/:areaId/:serviceId',
    name: 'myHealthHandover',
    component: LoggedIn,
    props: true,
  },
  {
    path: "/coaching-platform",
    name: "coachingPlatform",
    component: LoggedIn,
  },
  {
    path: "/f2f/:sessionId/:notificationId",
    name: "dmhF2F",
    component: LoggedIn,
  },
  {
    path: "/message/:sessionId/:type",
    name: "dmhMessage",
    component: LoggedIn,
  },
  {
    path: "/booking-video-room/:booking_id/:tests?",
    name: "bookingVideoRoom",
    component: LoggedIn
  },
  // {
  //   path: "/finance",
  //   name: "dmhFinance",
  //   component: LoggedIn,
  // },
  {
    path: "/learn-more",
    name: "dmhFaqs",
    component: LoggedIn
  },
  {
    path: "/faqs",
    name: "SpectrumFAQs",
    component: SpectrumFAQs,
  },
  {
    path: "/privacy-policy",
    name: "privacy",
    component: PrivacyPolicy
  },
  {
    path: "/privacy-policy-vpc",
    name: "privacy-vpc",
    component: PrivacyPolicyVpc
  },
  {
    path: "/cancellation-policy",
    name: "CancellationPolicy",
    component: CancellationPolicy
  },
  {
    path: "/terms-and-conditions/:type?",
    name: "TCs",
    component: TCs
  },
  {
    path: "/terms-and-conditions-vpc",
    name: "TCsVpc",
    component: TermsAndConditionsVpc
  },
  // {
  //   path: "/articles",
  //   name: "dmhArticles",
  //   component: LoggedIn,
  // }
  {
    path: "/mobile-redirect",
    name: "mobileRedirect",
    component: StripeMobileRedirect
  },
  {
    path: "/mobile-transaction-cancelled",
    name: "mobileTransactionCancelled",
    component: StripeMobileRedirect
  },
  {
    path: "*",
    name: "NotFound",
    component: NotFound
  }
];

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

// const token = new URLSearchParams(window.location.search).get("token");

// if there is a token provided by the user in the route, we save it locally to be used later for sign in in NotLoggedIn component
// if (token) {
//   localStorage.setItem("access_token", token);
//   const params = new URLSearchParams(window.location.search);
//   params.delete("token");
//   localStorage.setItem(
//     "queryWithoutToken",
//     window.location.pathname + "?" + params.toString()
//   );
// } else {
//   localStorage.setItem("access_token", null);
// }

// if (store.getters.hardcoded && store.getters.hardcoded.permittedRoutes) {
//   router.beforeEach((to, from, next) => {
//     if (
//       !store.getters.hardcoded.permittedRoutes.includes(to.name)
//     ) {
//       try {
//         next(store.getters.homeRoute);
//       } catch (e) {
//         console.log(e)
//         next('/login')
//       }
//     }
//     next();
//   });
// }

// http://localhost:8080?token=QpmWU6u612tfOUEmOiWcQzI0Vm9PWktnK2gwNEJEQjREUVlKN2RIVVlpdENVajZ1WjNUUmZZRWhiVllOZk1WdDhjVHdsTzFQV0VPeFZKWTBDV212cFFvdTBmSlI3V1o4Vy9xV0owaGxVWS93MmVkVVQxN3NQcnBOMkVlMGJXa2NKekQvaGNIdWNrcUhsM29MaUN0UVF1SXovUEZOR0VycnhpUVN0T2JzQkpnRktFQ3ZZSi84NzUxU3h0ZlMzNy9ITHN2a0lqOWdYY3c2WHorNXVaUFNtbkhpU2VvQ1IvN2swK0lEQm1zK0E3U2NJRG1xVjcyaDI3dmF4dkxIK0xwY2ZKUEgvZDJlRVlrSlFiMHJwYnl5TXdkdXdVdG9ieDJvcTZYb2R6eERhYXdpVi8rdll0QmpocWhSVytKbFhpakFwMWJ3bldBL0hzZ2F1ekpp


router.beforeEach(async (to, from, next) => {

  if (to.query.back_url) {
    try {
      store.commit("setRedirectUrl", atob(to.query.back_url));
    } catch (e) {
      console.error("Invalid back_url", e);
    }
  }

  if(to.query.token) {
    await handleHandover({ to, from, next });
    return;
  }

  next();
});

export default router;
